import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table deposit report view.
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the datatable for deposit reports.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user ID from parameters

        return {
            view: 'datatable', // DataTable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            height: screen !== 'small' ? 350 : 200, // Set height based on screen size
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Row height
                    template: function (obj) {
                        // Template for detail icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                    footer: 'Total:', // Footer text
                },
                { id: 'Id', header: 'ID', width: 70, sort: 'int' }, // ID column
                {
                    id: 'ClientId',
                    header: 'ID Usuario', // User ID column
                    width: 95,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocal',
                    header: _('Fecha de Creación'), // Creation date column with localization
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date format
                },
                {
                    id: 'PaymentSystemName',
                    header: 'Nombre Sistema Pasarela Pago', // Payment system name column
                    width: 250,
                    sort: 'int',
                },
                { id: 'TypeName', header: 'Tipo', width: 100, sort: 'int' }, // Type column
                { id: 'CurrencyId', header: 'Moneda', width: 70, sort: 'int' }, // Currency column
                {
                    id: 'Amount',
                    header: 'Valor', // Amount column
                    width: 100,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price format
                    exportType: 'number', // Export type
                    footer: { content: 'summColumn' }, // Footer content
                    editor: 'text', // Editor type
                },
                {
                    id: 'ModifiedLocal',
                    header: _('Modificado'), // Modified date column with localization
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date format
                },
                {
                    id: 'State',
                    header: 'Estado', // State column
                    options: [
                        // State options
                        { id: '', value: 'None' },
                        { id: 'A', value: 'Pagada' },
                        { id: 'C', value: 'Canceled' },
                        { id: 'I', value: 'Inactivo' },
                        { id: 'R', value: 'Rechazada' },
                    ],
                },
                {
                    id: 'ExternalId',
                    header: 'External ID', // External ID column
                    width: 150,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for detail icon click
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
            },
            footer: true, // Enable footer
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API URL for data fetching
            url: devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2?PlayerId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user ID
        var url = grid.data.url; // Data URL

        // Event listener for filtering deposit reports
        this.on(this.app, 'depositReportPlayer:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('deposit:id', [item.Id]); // Trigger deposit ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + user, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
